export const NUMBER_OF_RESULTS_SHORT = 3
export const NUMBER_OF_RESULTS_MEDIUM = 8
export const NUMBER_OF_RESULTS_LONG = 15
